import { Group, Text, rem } from '@mantine/core';
import { Dropzone, MIME_TYPES } from '@mantine/dropzone';
import { IconFile, IconUpload, IconX } from '@tabler/icons-react';

interface FileDropzoneProps {
  onFileAccepted: (file: File) => void;
  loading?: boolean;
}

export function FileDropzone({ onFileAccepted, loading = false }: FileDropzoneProps) {
  return (
    <Dropzone
      onDrop={(files) => {
        if (files.length > 0) onFileAccepted(files[0]);
      }}
      maxSize={100 * 1024 * 1024}
      accept={[MIME_TYPES.csv, 'text/plain', '.txt']}
      loading={loading}
    >
      <Group justify="center" gap="xl" style={{ minHeight: rem(220), pointerEvents: 'none' }}>
        <Dropzone.Accept>
          <IconUpload
            style={{ width: rem(52), height: rem(52), color: 'var(--mantine-color-blue-6)' }}
            stroke={1.5}
          />
        </Dropzone.Accept>
        <Dropzone.Reject>
          <IconX
            style={{ width: rem(52), height: rem(52), color: 'var(--mantine-color-red-6)' }}
            stroke={1.5}
          />
        </Dropzone.Reject>
        <Dropzone.Idle>
          <IconFile
            style={{ width: rem(52), height: rem(52), color: 'var(--mantine-color-dimmed)' }}
            stroke={1.5}
          />
        </Dropzone.Idle>

        <div>
          <Text size="xl" inline>
            Drag your genetic data file here
          </Text>
          <Text size="sm" c="dimmed" inline mt={7}>
            Supports 23andMe and AncestryDNA raw data files (up to 100MB)
          </Text>
        </div>
      </Group>
    </Dropzone>
  );
}
